
import ColorPicker from './color-picker'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { Button } from '@/components/ui/button'
import { Type, PaintBucket, type LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

const Icons: Record<string, LucideIcon> = {
  Type,
  PaintBucket,
}

interface DropdownColorPickerProps {
  disabled?: boolean
  color: string
  onChange: (color: string, skipHistory?: boolean) => void
  buttonIcon: string
  title: string
  className?: string
}

export default function DropdownColorPicker({
  disabled = false,
  color,
  onChange,
  buttonIcon,
  title,
  className,
}: DropdownColorPickerProps) {
  const Icon = Icons[buttonIcon] || Type

  return (
    <Popover modal={false}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          disabled={disabled}
          title={title}
          className={cn('h-8 w-8 p-0', className)}
        >
          <Icon className="h-4 w-4 text-gray-500" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <ColorPicker color={color} onChange={onChange} />
      </PopoverContent>
    </Popover>
  )
}
